import { Stack, styled, Theme } from '@mui/material';
import arrowRight from 'public/images/home/arrow-right.svg';

export const HowWorksWrapper = styled('div')(({ theme }: { theme: Theme }) => ({
  padding: theme.spacing(10, 0, 10),
  backgroundColor: theme.palette.grey[100],
  [theme.breakpoints.up('md')]: {
    padding: theme.spacing(18, 0),
  },
}));

export const HowWorksItemTitle = styled((props) => (
  <Stack spacing={2} alignItems="center" {...props} />
))<{ need_arrow: number }>`
  background-color: ${({ theme }) => theme.palette.common.white};
  border-radius: ${({ theme }) => theme.spacing(2)};
  padding: ${({ theme }) => theme.spacing(0, 3, 2)};
  height: 100%;

  &:after {
    content: '';
    position: absolute;
    left: calc(50% + 22px);
    bottom: ${({ theme }) => theme.spacing(-10)};
    transform: translateX(50%) rotate(90deg);
    background-image: url('${arrowRight}');
    width: 24px;
    height: 24px;
    opacity: ${({ need_arrow }) => need_arrow};
  }

  ${({ theme }) => theme.breakpoints.up('lg')} {
    &:after {
      left: 100%;
      bottom: auto;
      top: ${({ theme }) => theme.spacing(33.5)};
      transform: translateX(50%);
    }
  }
`;

export const HowWorksItemTitleText = styled('h3')`
  font-weight: 700;
  font-size: ${({ theme }) => theme.spacing(6)};
  line-height: 1.5;
  text-align: center;
  color: #525255;

  ${({ theme }) => theme.breakpoints.up('md')} {
    font-size: ${({ theme }) => theme.spacing(5.75)};
    line-height: 1.3;
  }
`;

export const HowWorksItemDesc = styled('p')`
  font-size: ${({ theme }) => theme.spacing(3.5)};
  line-height: 1.38;
  padding-bottom: 39px;
  margin-top: ${({ theme }) => theme.spacing(2.5)};
  color: ${({ theme }) => theme.palette.grey[500]};
`;
